import React, { useContext, useRef } from 'react';
import LocaleContext from 'constants/localization';
import { Editor } from '@tinymce/tinymce-react';

export default function RichTextDisplay({value}) {
  const LS = useContext(LocaleContext);
  const editorRef = useRef(null);
  
  return (
    <React.Fragment>
      <Editor
        onInit={(evt, editor) => editorRef.current = editor}
	tinymceScriptSrc="js/tinymce/tinymce.min.js"
        value={value}
        init={{
        height: 400,
        menubar: false,
        inline: true,
    	readonly: 1,
    	editable_root: false,
        content_style: 'body { font-family:"Open sans",sans-serif; font-size:1em }'
        }}
      />
    </React.Fragment>
  );
}
